import { IEnvironment } from './environment.type';

// We don't use partial here since this prevents us from just spreading this env into the specific once since all fields
// are made optional.
export const baseEnv: IEnvironment = {
    backendUrl: 'https://app-iqenergy-euw-run-fe-apps1.azurewebsites.net',
    useMockServices: false,
    useMockAuthentication: false,
    identityProviders: {
        authZero: {
            authConfig: {
                issuer: 'https://auth-eisdev.eon.com/',
                redirectUri: window.location.origin + '/auth/login-redirect',
                clientId: 'riQA4YheX0A54wGZmnlZZRIQkxY54ITh',
                responseType: 'code',
                scope: 'openid profile email offline_access',
                showDebugInformation: true,
            },
        },
    },
}
